/**
 * Form for creating a new root scorecard.  See
 * https://www.dropbox.com/s/o8un4yqgz839wwp/scorecard-create.psd?dl=0
 */

import Backbone from 'backbone'

import template from './root-form.hbs'
import i18n from 'scoreboard/components/i18n'
import formHelper from 'scoreboard/components/form-helper'
import _ from 'lodash'
import conductor from 'scoreboard/components/conductor'
import FormView from 'scoreboard/components/form-view'
import MarkedField from 'scoreboard/components/marked-field'
import requiredValidator from 'scoreboard/components/validators/required-validator'
import globals from 'scoreboard/components/globals'
import TagsChooser from 'scoreboard/components/tags-chooser'

var ScorecardForm = Backbone.View.extend({

	// this.model is a ScorecardNode

	tagName: 'form',

	className: 'root-form',

	initialize: function(options = {}) {
		this.options = options
		this.formView = new FormView({ el: this.el, submit: this.submit.bind(this) })
	},

	render: function() {
		var context = {
			heading: i18n.get('common.create2', i18n.get('scorecards.scorecard'))
		}
		this.$el.empty().append(template(context))

		this.labelField = new MarkedField({
			el: this.$('[name=label]'),
			validator: requiredValidator
		}).render()

		this.tagsChooser = new TagsChooser({
			el: this.$('[name=tags]'),
			tags: this.model.get('tags'),
			globalTags: this.options.globalTags
		}).render()

		this.formView.start()

		return this
	},

	submit: function(e) {
		e.preventDefault()

		var data = formHelper.readFromDom(this.$el)

		this.model.periodId = globals.periodId
		return this.model.save(data, {
			success: function(model) {
				model.set('type', 'root')
				Backbone.trigger('add:domain-object', model)
				// i hate to issue a new request since we already should have
				// most of the data we need, but creating scorecard roots
				// shouldn't happen nearly as often as other things (e.g.
				// creating non-roots), so for now I'm just going to do this
				// the easy way and issue another request
				conductor.navigate('scorecards/' + model.id + '/new', { trigger: true })
				this.trigger('done')
			}.bind(this)
		})
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.formView, this.labelField, this.tagsChooser], 'remove')
	}

})

export default ScorecardForm

ScorecardForm.__filename__ = 'scorecards/root-form.js'
